import { userService } from "../services";
import config from "../config/config";

export const SiteAction = {
  fetchSiteList,
  addSiteAccess,
  removeSiteAccess,
  removeGeofench,
  fetchSiteRouteSubSite,
  fetchCreateSource,
  fetchCreateSDestination,
};

async function fetchSiteList(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.SiteList}?companyId=${
      payload.companyId
    }&status=${payload.status ? payload.status : ""}&userId=${
      JSON.parse(localStorage.getItem("data")).id
    }&showSubSite=${payload.showSubSite == "false" ? false : true}&fetchCordinates=${payload.fetchCordinates === true ? true : false}`;
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchSiteRouteSubSite(payload) {
  try {
    const apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.routeSiteSubSite
    }?companyId=${payload.companyId}&showRoute=${payload.showRoute}&userId=${
      JSON.parse(localStorage.getItem("data")).id
    }&showSubSite=${payload.showSubSite}`;

    const response = await userService.get(apiEndpoint);

    if (response && response.status === 200) {
      const data = response.data;

      // 🔥 FILTER sites with invalid latitude/longitude
      const filteredSiteDTOList =
        data?.siteDTOList?.filter(
          (site) =>
            site?.latitude != null &&
            site?.longitude != null &&
            site.latitude !== 0 &&
            site.longitude !== 0,
        ) || [];

      // return cleaned response (do NOT mutate original)
      return {
        ...data,
        siteDTOList: filteredSiteDTOList,
      };
    } else {
      console.log(response);
      alert(response?.data?.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function removeGeofench(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.removeGeoFench
    }?companyId=${payload.companyId}&siteId=${
      payload.siteId ? payload.siteId : ""
    }&userId=${JSON.parse(localStorage.getItem("data")).id}&subSiteId=${
      payload.subSiteId ? payload.subSiteId : ""
    }`;
    ////debugger;
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response;
    } else {
      console.log(response);
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function addSiteAccess(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.AddSiteAccess}`;
    ////debugger;
    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 201) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function removeSiteAccess(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.RemoveSiteAccess}`;
    ////debugger;
    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchCreateSource(payload) {
  debugger;
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.createSource}`;
    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response?.data?.responseDescription);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchCreateSDestination(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.createDestination}`;
    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response?.data?.responseDescription);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
